/**
 * this only exists for compatability with the legacy theme and can be reoved once the legacy theme is removed
 */
export const spacingLegacy = {
  none: '0',
  xSmall: '0.25rem',
  small: '0.5rem',
  medium: '1rem',
  large: '1.5rem',
  xlarge: '2.5rem'
};